import {PopoverProps, UserPopoverProps} from "../../types/types";
import Popover from "../../ui/Popover";
import Button from "../../ui/Button";
import {useCopyClipboard, useUserInfo} from "../../hooks";
import {PropsWithChildren, useState} from "react";
import ProfileIcon from "../../assets/icon/ProfileIcon";
import {ArrowRightIcon, CheckIcon, CopyIcon} from "../../assets/icon";
import {truncateAddress} from "../../utils";
import {UsernameModal} from "../index";
import {FormattedMessage, useIntl} from "react-intl";

function UserContent() {
    const {logout,address,username} = useUserInfo()
    const [logouting, setLogouting] = useState(false)

    const onLogout = async () => {
        if (logouting) return
        try {
            setLogouting(true)
            await logout()
        } catch (error) {
            console.error(error)
        } finally {
            setLogouting(false)
        }
    }
    const UserItem = ({
        children,
        icon,
        rightIcon,
        onClick
                      }:PropsWithChildren&{
        icon?:React.ReactNode,
        rightIcon?:React.ReactNode,
        onClick?:()=>void
    })=>{
        return <div className={"matchid-user-popover-item"} onClick={onClick}>
            <div className={`matchid-user-popover-item-content`}>
                {icon}
                <div className={"matchid-user-popover-item-text"}>
                    {children}
                </div>
            </div>
            {rightIcon}
        </div>

    }
    const UserDivider = ()=>{
        return <div className={`matchid-user-popover-divider`}></div>
    }

    const [usernameOpen,setUsernameOpen] = useState(false)
    const [copied, setCopied] = useCopyClipboard();
    const intl = useIntl()
    return <div className={"matchid-user-popover-content"}>
        <div className={"matchid-user-popover-list"}>
            <UserItem  onClick={()=>{
                setCopied(address)
            }} icon={copied ?<CheckIcon size={20} color="#0ecb81"/> : <CopyIcon size={20} color="var(--icon-color)"/>} rightIcon={<CheckIcon size={20} color="var(--icon-color)"/>}>
                {truncateAddress(address)}
            </UserItem>
            <UserDivider/>
            <UserItem onClick={()=>{
                setUsernameOpen(true)
            }} icon={<ProfileIcon size={20} color="var(--icon-color)"/>} rightIcon={<ArrowRightIcon size={20} color="var(--icon-color)"/>}>
                {username || intl.formatMessage({
                    id:"setUsername"
                })}
            </UserItem>
        </div>
        <Button onClick={onLogout} loading={logouting}><FormattedMessage id="disconnect"/></Button>
        <UsernameModal isOpen={usernameOpen} onClose={()=>{
            setUsernameOpen(false)
        }} onSuccess={()=>{
            setUsernameOpen(false)
        }}/>
    </div>
}

export default function UserPopover({
                                        children,
                                        ...props
                                    }: UserPopoverProps) {
    return <Popover {...props} content={<UserContent/>}>
        {children}
    </Popover>

}